import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  hasUserAccess,
  getUserDetails,
  getUserRole,
} from "../../../../backend/auth";
import {
  useGetVendorHeirarchyRecords
} from "../../../../backend/masters";

const INCLUDE_USER_COMPANY_ASSOCIATIONS = {
  parent_company: {
    associate_companies: {
      company_location_mappings: {
        location: ['city']
      }
    }
  }
};

function AdminVendorLocations({ onChange, previousFilters }: any) {
  const _role = getUserRole();
  const [t] = useState(new Date().getTime());
  const [associateCompanies, setAssociateCompanies] = useState<any>(null);
  const [locations, setLocations] = useState<any>(null);
  const [categories, setCategories] = useState<any>(null);
  const [vendors, setVendors] = useState<any>(null);

  const [company, setCompany] = useState<any>(null);
  const [associateCompany, setAssociateCompany] = useState<any>(null);
  const [location, setLocation] = useState<any>(null);
  const [category, setCategory] = useState<any>(null);
  const [vendor, setVendor] = useState<any>(null);
  const user = getUserDetails();

  const { companies, isFetching }: any = useGetVendorHeirarchyRecords({
    filters: {
      user_id_eq: user.user_id
    },
    // includes: INCLUDE_USER_COMPANY_ASSOCIATIONS
  });

  useEffect(() => {
    if (company) {
      const _company = companies.find((c: any) => c.id == company.value)
      setAssociateCompanies(_company.associate_companies);
      setAssociateCompany(undefined);
    }
  }, [company]);

  useEffect(() => {
    if (associateCompany) {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      setLocations(_associateCompany.locations)
    }
  }, [associateCompany]);

  useEffect(() => {
    if (location) {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      const _location = _associateCompany? _associateCompany.locations.find((c: any) => c.id == location.value) : {}
      setCategories(_location.categories)
    }
  }, [location]);

  useEffect(() => {
    if (category) {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      const _location = _associateCompany.locations.find((c: any) => c.id == location.value)
      const _category = _location.categories.find((c: any) => c.id == category.value)
      setVendors(_category.vendors);
    }
  }, [category]);

  useEffect(() => {
    if (
      company &&
      associateCompany &&
      location &&
      vendor &&
      category
    ) {
      onChange({
        company_id_eq: company.value,
        associate_company_id_eq: associateCompany.value,
        location_id_eq: location.value,
        vendor_category_id_eq: category.value,
        vendor_registration_id_eq: vendor.value,
      },
      {
        company,
        associateCompany,
        locations: [location],
        vendorCategories: [category],
        vendorRegistrations: [vendor]
      });
    }
  }, [vendor]);

  useEffect(() => {
    if(companies && companies.length > 0 && !isFetching) {
      let _company = companies[0];
      if(Object.keys(previousFilters).length){
        _company = companies.find((as: any) => as.id == (previousFilters.company || {}).value) || companies[0];
      }
      if (_company) {
        setCompany({ value: _company.id, label: _company.name });
        setAssociateCompanies(_company.associate_companies);
      }
    }
  }, [companies])

  useEffect(() => {
    if(associateCompanies && associateCompanies.length > 0) {
      let _company = associateCompanies[0];
      if(Object.keys(previousFilters).length){
        _company = associateCompanies.find((as: any) => as.id == (previousFilters.associateCompany || {}).value) || associateCompanies[0];
      }
      if (_company) {
        setAssociateCompany({ value: _company.id, label: _company.name });
        setLocations(_company.locations);
      }
    }
  }, [associateCompanies])

  useEffect(() => {
    if(locations && locations.length > 0) {
      let _location = locations[0];
      if(Object.keys(previousFilters).length){
        _location = locations.find((as: any) => as.id == ((previousFilters.locations || [])[0] || {}).value) || locations[0];
      }
      if (_location) {
        setLocation({ value: _location.id, label: _location.name });
        setCategories(_location.categories);
      }
    }
  }, [locations])

  useEffect(() => {
    if(categories && categories.length > 0) {
      let _category = categories[0];
      if(Object.keys(previousFilters).length){
        _category = categories.find((as: any) => as.id == ((previousFilters.vendorCategories || [])[0] || {}).value) || categories[0];
      }
      if (_category) {
        setCategory({ value: _category.id, label: _category.name });
        setVendors(_category.vendors);
      }
    }
  },[categories])

  useEffect(() => {
    if(vendors && vendors.length > 0) {
      let _vendor = vendors[0];
      if(Object.keys(previousFilters).length){
        _vendor = vendors.find((as: any) => as.id == ((previousFilters.vendorRegistartions || [])[0] || {}).value) || vendors[0];
      }
      if (_vendor) {
        setVendor({ value: _vendor.id, label: _vendor.name });
      } else {
        setVendor(null);
      }
    } else {
      setVendor(null);
    }
  },[vendors])

  function selectVendor(selected: any) {
    if(selected.value === vendor.value) {
      return
    } else {
      setVendor(selected);
    }
  }

  return (
    <>
      <div className="px-2">
        <label className="filter-label">
          <small>Company</small>
        </label>
        <Select
          placeholder="Company"
          options={(companies || []).map((x: any) => {
            return { value: x.id, label: x.name };
          })}
          onChange={setCompany}
          value={company}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Associate Company</small>
        </label>
        <Select
          placeholder="Associate Company"
          options={
            Array.isArray(associateCompanies)
              ? associateCompanies.map((x: any) => ({
                  value: x.id,
                  label: x.name,
                }))
              : []
          }
          onChange={setAssociateCompany}
          value={associateCompany}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Location</small>
        </label>
        <Select
          placeholder="Location"
          options={
            Array.isArray(locations)
              ? locations.map((x: any) => ({
                  value: x.id,
                  label: x.name,
                }))
              : []
          }
          onChange={setLocation}
          value={location}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor Category</small>
        </label>
        <Select
          placeholder="Category"
          options={(categories || []).map((x: any) => {
            return { value: x.id, label: x.name };
          })}
          onChange={setCategory}
          value={category}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor</small>
        </label>
        <Select
          placeholder="Vendors"
          options={
            Array.isArray(vendors)
              ? vendors.map((x: any) => ({
                  value: x.id,
                  label: x.name,
                }))
              : []
          }
          onChange={selectVendor}
          value={vendor}
          className="select-control"
        />
      </div>
    </>
  );
}

export default AdminVendorLocations;
